import { useContext } from 'react';
import { Handle, Position, useReactFlow } from '@xyflow/react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowHQDataFetchNode({ id, data }) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();


    function handleShowHQFetcConfigurationClick() {
        let node = reactFlowInstance.getNode(id);
        context.setActiveEditHQFetchNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }



    return (
        <div className={ "workflow-node hq-data-fetch " + id + " "  + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="hq-fetch-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>

            <div className="node__layout">
                <div className="layout__top">
                    <span className="hq-fetch-icon" />
                    <div className="nn-logo">
                        <img src="/images/icon/nn-logo.png" alt="Nok Nok Logo" />
                    </div>
                </div>
                <div className="layout__middle">
                    <span className="label-span">{ (typeof data?.label === 'string' && data.label.length > 0) ? data.label : "HQ Fetch Node" }</span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ handleShowHQFetcConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>

            <Handle
                type="source"
                position={Position.Bottom}
                id="hq-fetch-source"
            >
                <span className="handle-label bottom" >{ "Output" }</span>
            </Handle>

        </div>
    );
}

export default WorkflowHQDataFetchNode;